import React, {useMemo} from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';

import {IRisksRequestDto} from '../api/types';
import {RequestDetailsModal} from '../ui/request-details-modal';

interface IUseRisksRequestsColumnsArgs {
    isCreateAllowed: boolean;
    onRefreshed: () => void;
}

export const useRisksRequestsColumns = ({
    isCreateAllowed,
    onRefreshed,
}: IUseRisksRequestsColumnsArgs): IUseCustomTableArgs['columns'] =>
    useMemo(
        () => [
            {
                title: 'Номер запроса',
                dataIndex: 'requestId',
                render: (_: string, record: IRisksRequestDto) => (
                    <RequestDetailsModal
                        value={record.id}
                        fields={record}
                        isCreateAllowed={isCreateAllowed}
                        onRefreshed={onRefreshed}
                    />
                ),
                width: '15%',
            },
            {title: 'Тип запроса', dataIndex: 'requestTypeName', width: '20%'},
            {title: 'Дата запроса', dataIndex: 'createdRequestDate', width: '12%'},
            {title: 'Статус', dataIndex: 'statusName', width: '13%'},
            {title: 'Плановая дата ответа', dataIndex: 'plannedResponseDate', width: '13%'},
            {title: 'Фактическая дата ответа', dataIndex: 'factResponseDate', width: '13%'},
            {title: 'Номер ответа', dataIndex: 'responseId', width: '14%'},
        ],
        [isCreateAllowed, onRefreshed]
    );
